var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGameShow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_521705)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 20.1978H14.9691V23.9998H9V20.1978Z",
    fill: "#5E5C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 20.1978H14.9691V23.9998H12V20.1978Z",
    fill: "#4A3E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 21.0002C6.62055 21.0002 2.25977 16.6394 2.25977 11.2601C2.25977 6.39068 5.83258 2.35615 10.4999 1.63428L20.4951 8.87942L11.9999 21.0002Z",
    fill: "#FFDF46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7402 11.2601C21.7402 16.6394 17.3794 21.0002 12 21.0002V1.63428H13.5C18.1673 2.35615 21.7402 6.39068 21.7402 11.2601Z",
    fill: "#FFB300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6308 11.2598L12.0006 17.9928C10.1411 17.9928 8.45784 17.239 7.23961 16.0207L5.26758 11.2598C5.26758 9.40036 6.02137 7.71707 7.23961 6.49884L12.0006 4.52686L14.6308 11.2598Z",
    fill: "#0ADCF0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.733 11.2598C18.733 13.1193 17.9792 14.8026 16.761 16.0208L12 17.9928V4.52686C13.8594 4.52686 15.5427 5.28065 16.761 6.49889L18.733 11.2598Z",
    fill: "#16A4D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9992 4.52686C10.1399 4.52686 8.4567 5.28047 7.23828 6.49889L11.9992 11.2598V4.52686Z",
    fill: "#F6F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.733 11.2594C18.733 9.40019 17.9794 7.71696 16.761 6.49854L12 11.2594H18.733Z",
    fill: "#E2DFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17.9927C13.8593 17.9927 15.5425 17.2391 16.7609 16.0207L12 11.2598V17.9927Z",
    fill: "#E2DFF5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.26758 11.2598C5.26758 13.119 6.02119 14.8023 7.23961 16.0207L12.0006 11.2598H5.26758Z",
    fill: "#F6F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0004 13.0081C12.966 13.0081 13.7488 12.2253 13.7488 11.2597C13.7488 10.294 12.966 9.51123 12.0004 9.51123C11.0348 9.51123 10.252 10.294 10.252 11.2597C10.252 12.2253 11.0348 13.0081 12.0004 13.0081Z",
    fill: "#5E5C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7484 11.2597C13.7484 12.2253 12.9656 13.0081 12 13.0081V9.51123C12.9656 9.51123 13.7484 10.294 13.7484 11.2597Z",
    fill: "#4A3E64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 0L12.6144 1.95937L12 3.91875L10.5 3.31828V0L12 0Z",
    fill: "#FF3D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0V3.31828L12 3.91875V0L13.5 0Z",
    fill: "#B30361"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.31836V6.00008L12 7.20148L10.5 6.00008V3.31836H13.5Z",
    fill: "#5E5C94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.31836V6.00008L12 7.20148V3.31836H13.5Z",
    fill: "#4A3E64"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_521705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGameShow);
export default __webpack_public_path__ + "static/media/game-show.e01306eea0be5394e9bfbf5e069ff247.svg";
export { ForwardRef as ReactComponent };